export { default } from './SquigglyLine';
